module.exports = __webpack_public_path__ + "img/21CreekRdLot6HabitatPlan20100810_Mobile.e5b1af9e.png";